import { useEffect, useState } from "react";
import Image from "../assets/Property.png";
import { HiChevronDoubleDown } from "react-icons/hi";
import api from "../common/apiClient";
import SummaryApi from "../common/SummaryApi";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
export default function PropertyListing() {
  const [properties, setProperties] = useState([]);
  const [filteredProps, setFilteredProps] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState("All Properties");
  const [showAll, setShowAll] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const fetchProperties = async () => {
    try {
      const res = await api({
        url: SummaryApi.getAllProperties.url,
        method: SummaryApi.getAllProperties.method,
      });

      const data = res.data?.data || [];

      // 🔥 clean mapping
      const mapped = data.map((p) => ({
        id: p._id,
        title: p.title?.trim(),
        category: p.category?.trim(),
        location: p.location?.trim(),
        size: p.landSize,
        road: p.roadAccess,
        water: p.waterSource,
        legal: p.legalStatus,
        pricing: p.pricing,
        image:
          p.heroImage?.url ||
          p.gallery?.[0]?.url ||
          Image,
      }));

      setProperties(mapped);
      setFilteredProps(mapped);

      const uniqueCats = [...new Set(mapped.map((p) => p.category))];
      setCategories(uniqueCats);

    } catch (err) {
      console.error("Property fetch error:", err);
    }
  };
  useEffect(() => {
    fetchProperties();
  }, []);
  //  filter
  const handleCategoryClick = (cat) => {
    setActiveCategory(cat);

    // ✅ URL update
    if (cat === "All Properties") {
      setSearchParams({});
    } else {
      setSearchParams({ category: cat.replace(/\s+/g, "-") });
    }

    if (cat === "All Properties") {
      setFilteredProps(properties);
    } else {
      setFilteredProps(
        properties.filter((p) => p.category === cat)
      );
    }
  };

  useEffect(() => {
    const categoryFromUrl = searchParams.get("category")?.replace(/-/g, " ");

    if (categoryFromUrl) {
      setActiveCategory(categoryFromUrl);

      setFilteredProps(
        properties.filter((p) => p.category === categoryFromUrl)
      );
    } else {
      setActiveCategory("All Properties");
      setFilteredProps(properties);
    }
  }, [searchParams, properties]);

  const displayedProps = showAll ? filteredProps : filteredProps.slice(0, 5);

  return (
    <section className="container mx-auto py-12 px-4">

      {/* HEADER */}
      <div className="mb-10">
        <h2 className="text-4xl md:text-5xl font-medium font-times mb-2 text-[#2F2F2F]">
          Premium Property Listings
        </h2>
        <p className="text-[#64748B] max-w-3xl">
          High-impact estates and plots across Idukki, curated for the discerning investor seeking luxury and serenity.
        </p>
      </div>

      {/* FILTERS */}
      <div className="mb-10 overflow-x-auto scrollbar-hide">
        <div className="flex gap-4 min-w-max">

          {/* ALL BUTTON */}
          <button
            onClick={() => handleCategoryClick("All Properties")}
            className={`px-6 py-2.5 rounded-full text-sm whitespace-nowrap border transition ${
              activeCategory === "All Properties"
                ? "bg-[#45A301] text-white border-[#45A301]"
                : "bg-white text-[#64748B] border-[#E2E8F0]"
            }`}
          >
            All Properties
          </button>

          {/* CATEGORY BUTTONS */}
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => handleCategoryClick(cat)}
              className={`px-6 py-2.5 rounded-full text-sm whitespace-nowrap border transition capitalize ${
                activeCategory === cat
                  ? "bg-[#45A301] text-white"
                  : "bg-white border-[#E2E8F0] text-[#475569]"
              }`}
            >
              {cat}
            </button>
          ))}

        </div>
      </div>

      {/* CARDS */}
      <div className="space-y-10">
        {displayedProps.map((property) => (
          <div
            key={property.id}
            className="flex flex-col lg:flex-row bg-white rounded-2xl shadow-sm overflow-hidden p-4"
          >
            {/* IMAGE */}
            <div className="lg:w-[60%] h-[260px] md:h-[280px] lg:h-[420px] overflow-hidden relative">

              {/*  BADGE */}
              <div className="absolute top-4 left-4 bg-[#45A301] text-white text-xs px-4 py-1.5 rounded-full shadow">
                {property.category}
              </div>

              <img
                src={property.image}
                alt={property.title}
                onError={(e) => {
                  e.target.src = Image;
                }}
                className="w-full h-full object-fill rounded-lg"
              />
            </div>

            {/* DETAILS */}
            <div className="lg:w-[40%] px-4 lg:px-6 py-4 flex flex-col justify-between">
              <div>
                <h3 className="text-2xl font-medium mb-6 text-[#0F172A] font-times">
                  {property.title}
                </h3>

                <div className="space-y-4 text-base">

                <div className="flex flex-col sm:flex-row sm:justify-between border-b border-[#F1F5F9] pb-2 gap-1">

                  <span className="text-[#989898]">Location</span>

                  <span className="text-[#334155] sm:text-right max-w-[70%] break-words">
                    {property.location}
                  </span>

                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between border-b border-[#F1F5F9] pb-2 gap-1">
                  <span className="text-[#989898]">Size</span>
                  <span className="text-[#334155] sm:text-right">{property.size}</span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between border-b border-[#F1F5F9] pb-2 gap-1">
                  <span className="text-[#989898]">Road Access</span>
                  <span className="text-[#334155] sm:text-right">{property.road}</span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between border-b border-[#F1F5F9] pb-2 gap-1">
                  <span className="text-[#989898]">Water</span>
                  <span className="text-[#334155] sm:text-right">{property.water}</span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between border-b border-[#F1F5F9] pb-2 gap-1">
                  <span className="text-[#989898]">Legal Docs</span>
                  <span className="text-[#334155] sm:text-right">{property.legal}</span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between gap-1 pb-2.5">
                  <span className="text-[#989898]">Price</span>
                  <span className="text-[#334155] sm:text-right">{property.pricing}</span>
                </div>

              </div>
              </div>

              <button
                onClick={() =>
                  navigate(`overview/${property.id}`, {
                    state: property.id
                  })
                }
                className="mt-6 bg-[#45A301] hover:bg-[#3e9202] text-white px-6 py-2.5 rounded-md text-base w-full"
              >
                View Property Details →
              </button>
            </div>
          </div>
        ))}
      </div>

      {filteredProps.length > 5 && (
        <div className="flex justify-center mt-12">
          <button
            onClick={() => setShowAll(!showAll)}
            className="flex items-center gap-2 px-8 py-2.5 rounded-full border border-[#45A301] text-[#45A301] text-base font-medium hover:bg-[#45A301] hover:text-white transition"
          >
            {showAll ? "Show Less" : "Explore More Properties"}
            <span className="text-lg"><HiChevronDoubleDown/></span>
          </button>
        </div>
      )}
    </section>
  );
}